<script setup lang="ts">
import type { DatabaseBackupResult } from '@/api/generator';
import Notification from '@/components/notifications/Notification.vue';
import type { NotificationMessage } from '@/components/notifications/types.ts';
import { useTranslation } from 'i18next-vue';
import { computed } from 'vue';

interface BackupResultProps {
  value: DatabaseBackupResult;
  fileNameOnly?: boolean;
}
const { value, fileNameOnly = false } = defineProps<BackupResultProps>();

const { t } = useTranslation();

const successNotification = computed<NotificationMessage | undefined>(() => {
  if (value.success) {
    return {
      type: 'success',
      title: t('DatabaseBackupSucceeded'),
      message: value.fileName ?? undefined,
      closable: false,
    };
  } else return undefined;
});
const failedNotification = computed<NotificationMessage | undefined>(() => {
  if (!value.success) {
    return {
      type: 'error',
      title: t('DatabaseBackupFailed'),
      message: value.errorMessage ?? undefined,
      closable: false,
    };
  } else return undefined;
});
</script>

<template>
  <div>
    <p v-if="fileNameOnly && value.fileName" class="text-body-2">{{ value.fileName }}</p>
    <template v-else>
      <Notification v-if="successNotification" :value="successNotification" class="mt-2" />
      <Notification v-if="failedNotification" :value="failedNotification" class="mt-2" />
    </template>
  </div>
</template>
